import React, {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
import {useDialogsContext} from '@/contexts/DialogsContext';
import {DIALOG_NAMESPACE} from '@/components/NewEmailDialog';

const Email = ({children, item, ...props}) => {
  const {openDialog: showEmail} = useDialogsContext(DIALOG_NAMESPACE);

  const handleClick = useCallback((e) => {
    e.stopPropagation();
    e.preventDefault();
    showEmail({emails: [item.email || item]});
  }, [item, showEmail]);

  return (
    <a type={'link'} className="px-0" {...props} onClick={handleClick}>{children}</a>
  );
};

export default memo(Email);

Email.propTypes = {
  children: PropTypes.any,
  item: PropTypes.any,
};
